export enum ScaleAnswer {
  NotApplicable = 'not applicable'
}
